const footer = () => {
    return ( 
        <footer>
    <h3>&copy; © 2025 CyberKon. All rights reserved.</h3>
</footer>
     );
}// Footer.jsx


export default footer;


 
